import FontFaceObserver from 'fontfaceobserver'

export function initFonts () {
  const armourFontObserver = new FontFaceObserver('Armour', {})
  const armourCondensedFontObserver = new FontFaceObserver('Armour-Condensed', {})

  return Promise.all([
    armourFontObserver.load(),
    armourCondensedFontObserver.load(),
  ]).then(() => {
    document.body.classList.add('font-loaded')
  }).catch(() => {
    document.body.classList.remove('font-loaded')
  })
}



// WEBPACK FOOTER //
// ./src/shared/fonts.js